<template>
    <div class="page-layout__content  page-layout__content--transparent  pt-0">
        <div class="row">
            <div class="col-3  pr-0">
                <div class="stat-card  stat-card--border-right  h-100">
                    <div class="stat-card__label">{{ getTranslation('allAppCount') }}</div>

                    <div class="stat-card__value">{{ appStats.count_all }}
                        <div v-if="appStats.new_count" class="stat-card__added" @click="redirectTo({route:'api.application.getList', query:{status:'NEW'}})" style="cursor: pointer">+{{ appStats.new_count }}</div>
                    </div>

                    <svg class="stat-card__img">
                        <use xlink:href="#icon__file-text"></use>
                    </svg>
                </div>
            </div>

            <div class="col-3  p-0">
                <div class="stat-card  stat-card--border-right  h-100">
                    <div class="stat-card__label">{{ getTranslation('allCandidateAppCount') }}</div>

                    <div class="stat-card__value">
                        {{ candidateOverAll.total }}
                    </div>

                    <svg class="stat-card__img">
                        <use xlink:href="#icon__users"></use>
                    </svg>
                </div>
            </div>

            <div class="col-3  p-0" @click="redirectTo({route:'api.testing.event.getList', query:{filter:'future'}})" style="cursor: pointer">
                <div class="stat-card  stat-card--border-right  h-100">
                    <div class="stat-card__label">{{ getTranslation('futureEventsCount') }}</div>

                    <div class="stat-card__value">
                        {{ eventStats.confirmedEventStats.eventCount + eventStats.newEventStats.eventCount }}
                        <div v-if="eventStats.newEventStats.eventCount" class="stat-card__added">+{{ eventStats.newEventStats.eventCount }}</div>
                    </div>

                    <svg class="stat-card__img">
                        <use xlink:href="#icon__briefcase"></use>
                    </svg>
                </div>
            </div>

            <div class="col-3  pl-0">
                <div class="stat-card  h-100">
                    <div class="stat-card__label">{{ getTranslation('allNewCandidateCount') }}</div>

                    <div class="stat-card__value">
                        {{ eventStats.confirmedEventStats.candidateCount + eventStats.newEventStats.candidateCount}}
                        <div v-if="eventStats.newEventStats.candidateCount" class="stat-card__added">+{{ eventStats.newEventStats.candidateCount }}</div>
                    </div>

                    <svg class="stat-card__img">
                        <use xlink:href="#icon__users"></use>
                    </svg>
                </div>
            </div>
        </div>
        <div class="row  mt-4  pt-2">
            <div class="col-6">
                <div class="section-2  h-100">
                    <div class="section-2__header  align-items-baseline">
                        <h2 class="section-2__title  mb-2">{{ getTranslation('statsByContestType') }}</h2>

                        <div class="section-2__nav  inner-2-navbar">
                            <div @click="filterBy(type.id,'byContest')" v-for="type in filterOptions.contestTypes" v-bind:key="type.id" class="inner-2-navbar__item " :class="{'inner-2-navbar__item--active':type.id===filterByContestType.contestType}">
                                <a class="inner-2-navbar__link" href="javascript:void(0)">{{ type.title }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="section-2__body  mt-4">
                        <div class="row">
                            <div class="col-12  col-xl-5  col-xxl-6">
                                <div class="chips-2">

                                    <div class="chips__group-2">

                                        <div class="chips__group-label-2  mb-2">{{ getTranslation('byGender') }}</div>

                                        <label v-for="gender in filterOptions.genders" class="chips__item-wrap-2">
                                            <input class="chips__input-2" name="gender" v-model="filterByContestType.gender" :value="gender.id" type="checkbox">

                                            <div class="chips__item-2  chips__item--with-check-icon-2  chips__item--shadow-0-2">
                                                <svg class="chips__check-icon-2">
                                                    <use xlink:href="#icon__shape-check"></use>
                                                </svg>

                                                <div class="chips__label-2">{{ gender.title }}</div>
                                            </div>
                                        </label>

                                    </div>
                                    <!-- /.chips__group -->

                                    <div class="chips__group-2  mt-4">

                                        <div class="chips__group-label-2  mb-5">{{ getTranslation('byAge') }}</div>

                                        <range-slider :min="0"
                                                      :max="100"
                                                      :interval="1"
                                                      v-model="filterByContestType.age"
                                                      :dot-options="[{tooltip: 'always'}, {tooltip: 'always'}]"
                                                      tooltip-formatter="{value}"
                                                      @drag-end="() => {fetchStatsByContestType(filter)}"
                                        ></range-slider>

                                    </div>
                                    <!-- /.chips__group -->

                                    <div class="chips__group-2  mt-4">

                                        <div class="chips__group-label-2  mb-2">{{ getTranslation('selectedLanguage') }}</div>

                                        <label class="chips__item-wrap-2">
                                            <input class="chips__input-2" name="lang" v-model="filterByContestType.lang" :value="'ru_RU'" type="checkbox">

                                            <div class="chips__item-2  chips__item--with-check-icon-2  chips__item--shadow-0-2">
                                                <svg class="chips__check-icon-2">
                                                    <use xlink:href="#icon__shape-check"></use>
                                                </svg>

                                                <div class="chips__label-2">{{ getTranslation('ru_RU') }}</div>
                                            </div>
                                        </label>

                                        <label class="chips__item-wrap-2">
                                            <input class="chips__input-2" name="lang" v-model="filterByContestType.lang" :value="'ky_KG'" type="checkbox">

                                            <div class="chips__item-2  chips__item--with-check-icon-2  chips__item--shadow-0-2">
                                                <svg class="chips__check-icon-2">
                                                    <use xlink:href="#icon__shape-check"></use>
                                                </svg>

                                                <div class="chips__label-2">{{ getTranslation('ky_KG') }}</div>
                                            </div>
                                        </label>

                                    </div>
                                    <!-- /.chips__group -->

                                </div>
                                <!-- /.chips -->
                            </div>
                            <div class="col-12  col-xl-7  col-xxl-6 ">
                                <BarChart
                                        v-if="showBar && showContestStats"
                                        :chart-options="contestChartOptions"
                                        :bar-data="byContestStats"
                                        :bar-height="300"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="section-2  h-100">
                    <div class="section-2__header  align-items-baseline">
                        <h2 class="section-2__title  mb-2">{{ getTranslation('appByMonthStatistics') }}</h2>

                        <div class="section-2__nav  inner-2-navbar">
                            <div @click="filterBy(type.id)" v-for="type in filterOptions.contestTypes" v-bind:key="type.id" class="inner-2-navbar__item " :class="{'inner-2-navbar__item--active':type.id===filterForm.contestType}">
                                <a class="inner-2-navbar__link" href="javascript:void(0)">{{ type.title }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="section-2__body  mt-4">

                        <div class="row">

                            <div class="col-12">

                                <BarChart
                                        v-if="showBar && showMonthStats"
                                        :chart-options="chartOptions"
                                        :bar-data="byMonthStats"
                                        :bar-height="300"
                                />

                            </div>

                        </div>
                        <!-- /.row -->

                    </div>
                </div>
            </div>
        </div>
        <div class="row  mt-4  pt-2">
            <div class="col-12">
                <div class="section-2  h-100">
                    <div class="section-2__header  align-items-baseline">
                        <h2 class="section-2__title  mb-2">{{ getTranslation('statsByOffice') }}</h2>
                    </div>
                    <div class="section-2__body  mt-4">

                        <div class="row">

                            <div class="col-12">
                                <BarChart
                                        v-if="showBar && showOfficeStats"
                                        :chart-options="officeChartOptions"
                                        :bar-data="byOfficeStats"
                                        :bar-height="300"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import BarChart from "@/components/BarChartComponent";

    const FILTER_ALL = 'ALL';
    const PERIOD_DEFAULT = 'YEAR'

    export default {
        name: "Home",
        components: { BarChart },
        data() {
            return {
                commonFilter: {
                    period: PERIOD_DEFAULT,
                },
                filterForm: {
                    contestType: FILTER_ALL,
                },
                filterByMonth: {
                    contestType: FILTER_ALL,
                },
                filterByDivision: {
                    divisionId: FILTER_ALL,
                },
                filterByOffice: {
                    officeId: '',
                },
                filterByContestType: {
                    gender: [],
                    age: [0, 100],
                    lang: [],
                    contestType: FILTER_ALL
                },
                filterOptions: {
                    contestTypes: [],
                    genders: [],
                },
                appStats: {
                    count_all: 0,
                    confirmed_count: 0,
                    rejected_count: 0,
                    new_count: 0
                },
                eventStats: {
                    newEventStats: {
                        candidateCount: 0,
                        eventCount: 0,
                        appCount: 0,
                        todayEventCount: 0
                    },
                    confirmedEventStats: {
                        candidateCount: 0,
                        eventCount: 0,
                        appCount: 0,
                        todayEventCount: 0
                    }
                },
                candidateOverAll: {
                    total: 0,
                    newCount: 0
                },
                byMonthStats: [],
                byOfficeStats: [],
                byContestStats: [],
                chartOptions: {
                    colors: ['#DEEAFF', '#7DCCAF'],
                    chart: {
                        type: 'line',
                        toolbar: {
                            show: true,
                            tools: {
                                download: false,
                                selection: false,
                                zoom: true,
                                zoomin: true,
                                zoomout: true,
                                pan: false,
                            },
                        },
                        width: "100%",
                        animations: {
                            initialAnimation: {
                                enabled: false
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    states: {
                        hover: {
                            filter: {
                                type: 'none',
                                value: 0,
                            }
                        }
                    },
                    grid: {
                        show: false,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    yaxis: {
                        show: false
                    },

                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: 'top',
                            },
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -10,
                        enabledOnSeries: [0],
                        style: {
                            colors: ["#2E71E5", '#19e5a0'],
                            fontSize: '14px',
                        }
                    },
                    xaxis: {
                        categories: [],
                        position: 'bottom',
                        axisTicks: {
                            show: false
                        },
                    },
                },
                officeChartOptions: {
                    colors: ['#DEEAFF', '#ffe9bf', '#C2F1E0'],
                    grid: {
                        show: false,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    chart: {
                        type: 'bar',
                        toolbar: {
                            show: false,
                        },
                        width: "100%",
                        animations: {
                            initialAnimation: {
                                enabled: false
                            }
                        }
                    },
                    tooltip: {
                        enabled: false,
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: []
                    },
                    yaxis: {
                        show: false
                    },
                    plotOptions: {
                        bar: {
                            endingShape: 'rounded',
                            dataLabels: {
                                position: 'top',
                            },
                            columnWidth: '55%',
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -24,
                        style: {
                            fontSize: '14px',
                            colors: ["#2E71E5"]
                        }
                    },
                    states: {
                        hover: {
                            filter: {
                                type: 'none',
                                value: 0,
                            }
                        }
                    },
                },
                contestChartOptions: {
                    colors: ['#DEEAFF'],
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        }
                    },
                    stroke: {
                        show: true,
                        colors: ['#80B0FF'],
                        width: 1
                    },
                    states: {
                        hover: {
                            filter: {
                                type: 'none',
                                value: 0,
                            }
                        }
                    },
                    xaxis: {
                        categories: [],
                        axisTicks: {
                            show: false
                        },
                        legend: {
                            position: 'left',
                            offsetY: 0
                        },
                        fill: {
                            opacity: 1
                        }
                    },
                    chart: {
                        type: 'bar',
                        stacked: false,
                        toolbar: {
                            show: false,
                        },
                        width: "100%",
                        animations: {
                            initialAnimation: {
                                enabled: false
                            }
                        }
                    },
                    yaxis: {
                        show: false,
                    },
                    tooltip: {
                        enabled: false,
                    },
                    legend: {
                        position: 'top',
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            dataLabels: {
                                position: 'bottom',
                            },
                        }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            legend: {
                                position: 'bottom',
                                offsetX: -10,
                                offsetY: 0
                            }
                        }
                    }],
                    dataLabels: {
                        enabled: true,
                        offsetY: 0,
                        style: {
                            fontSize: '14px',
                            colors: ["#2E71E5"]
                        }
                    }
                },
                showBar: false,
                showOfficeStats: false,
                showMonthStats: false,
                showContestStats: false
            }
        },
        computed: {
            filter() {
                return this.$store.getters['heading/getFilter'];
            },
        },
        watch: {
            'currentLocale'() {
                this.showBar = false;
                this.fetchOptions().then( () => {
                    this.showBar = true;
                } );
                this.fetchMainStats( this.filter );
                this.fetchStatsByMonth( this.filter );
                this.fetchStatsByOffice( this.filter );
                this.fetchStatsByContestType( this.filter );
            },
            'filter'( val ) {
                this.commonFilter.period = val;
                this.fetchMainStats( val );
                this.fetchStatsByMonth( val );
                this.fetchStatsByOffice( val );
                this.fetchStatsByContestType( val );
            },
            'filterByContestType.gender'() {
                this.fetchStatsByContestType( this.filter );
            },
            'filterByContestType.lang'() {
                this.fetchStatsByContestType( this.filter );
            }
        },
        updated() {
            this.setHeadings( { title: this.getTranslation( 'home' ) } );
        },
        created() {
            this.fetchOptions().then( () => {
                this.showBar = true;
            } );
            this.fetchMainStats();
            this.fetchStatsByMonth();
            this.fetchStatsByOffice();
            this.fetchStatsByContestType();
        },
        methods: {
            filterBy( id, stats = 'byMonth' ) {
                if ( stats === 'byMonth' ) {
                    this.filterForm.contestType = id;
                    this.fetchStatsByMonth( this.commonFilter.period );
                }
                if ( stats === 'byContest' ) {
                    this.filterByContestType.contestType = id;
                    this.fetchStatsByContestType( this.filter );
                }
            },
            fetchOptions() {
                return this.axios.get( this.$config.urls.application.fetchStatsOptions.url )
                           .then( response => {

                               this.filterOptions.contestTypes = response.data.data.contestTypes.map( item => {
                                   item.title = this.getTranslation( item.title );
                                   return item;
                               } );

                               this.filterOptions.genders = this.objectToArray( response.data.data.genders, true, true );

                               this.filterOptions.contestTypes.unshift( { id: FILTER_ALL, title: this.getTranslation( 'FILTER_ALL' ) } );

                               this.$store.dispatch( 'heading/setFilterOptions', this.objectToArray( response.data.data.statsOptions, false, true ) );

                           } ).catch(()=>{});
            },

            fetchMainStats( period = PERIOD_DEFAULT ) {
                let params = { period: period };
                this.axios.get( this.$config.urls.home.appStatistics.url, { params: params } )
                    .then( response => {

                        this.appStats = response.data.data.appStats

                        this.candidateOverAll = response.data.data.candidateOverAll;

                        let eventStats = response.data.data.eventStats;

                        if ( !Array.isArray( eventStats.newEventStats ) )
                            this.eventStats.newEventStats = eventStats.newEventStats;
                        else {
                            this.eventStats.newEventStats = {
                                candidateCount: 0,
                                eventCount: 0,
                                appCount: 0,
                                todayEventCount: 0
                            }
                        }

                        if ( !Array.isArray( eventStats.confirmedEventStats ) )
                            this.eventStats.confirmedEventStats = eventStats.confirmedEventStats;
                        else {
                            this.eventStats.confirmedEventStats = {
                                candidateCount: 0,
                                eventCount: 0,
                                appCount: 0,
                                todayEventCount: 0
                            };
                        }

                    } ).catch(()=>{});
            },

            fetchStatsByMonth( period = PERIOD_DEFAULT ) {
                let params = this.cleanObject( { ...this.filterForm, period: period } );
                this.axios.get( this.$config.urls.home.statsByMonth.url, { params: params } )
                    .then( response => {
                        let seriesData = [];
                        let confirmedData = [];
                        let labels = [];

                        for ( let item of response.data.data.byMonth ) {
                            seriesData.push( item.value );
                            labels.push( item.label );
                            confirmedData.push( item.confirmedCount );
                        }

                        this.chartOptions.xaxis.categories = labels;

                        this.byMonthStats = [
                            {
                                name: this.getTranslation( 'quantity' ),
                                data: seriesData,
                                type: 'column'
                            },
                            {
                                name: this.getTranslation( 'APPLICATION_CONFIRMED' ),
                                data: confirmedData,
                                type: 'line'
                            }
                        ];
                    } ).then( () => {
                    this.showMonthStats = true;
                } ).catch(()=>{});
            },

            fetchStatsByOffice( period = PERIOD_DEFAULT ) {
                let params = this.cleanObject( { ...this.filterByOffice, period: period } );
                this.axios.get( this.$config.urls.home.statsByOffice.url, { params: params } )
                    .then( response => {
                        let appliedCount = [];
                        let passedCount = [];
                        let tookPartCount = [];
                        let labels = [];

                        for ( let item of response.data.data ) {
                            labels.push( item.office_title );
                            appliedCount.push( item.applied_count );
                            passedCount.push( item.passed_count );
                            tookPartCount.push( ( item.failed_count + item.passed_count ) )
                        }
                        this.officeChartOptions.xaxis.categories = labels;
                        this.byOfficeStats = [
                            {
                                name: this.getTranslation( 'applied' ),
                                data: appliedCount
                            },
                            {
                                name: this.getTranslation( 'tookPart' ),
                                data: tookPartCount
                            },
                            {
                                name: this.getTranslation( 'candidatePassedCount' ),
                                data: passedCount
                            }
                        ];

                    } ).then( () => {
                    this.showOfficeStats = true;
                } ).catch(()=>{});
            },

            fetchStatsByContestType( period = PERIOD_DEFAULT ) {

                let params = this.cleanObject( { ...this.filterByContestType, period: period } );

                this.axios.get( this.$config.urls.home.statsByContestType.url, { params: params } )
                    .then( response => {

                        let seriesData = [];
                        let responseData = response.data.data;

                        seriesData.push( responseData.appliedCount );
                        seriesData.push( responseData.tookPartCount );
                        seriesData.push( responseData.passedCount );

                        this.contestChartOptions.xaxis.categories = [this.getTranslation( 'applied' ), this.getTranslation( 'tookPart' ), this.getTranslation( 'candidatePassedCount' )];

                        if ( responseData.hasOwnProperty( 'maleApplied' ) && responseData.hasOwnProperty( 'femaleApplied' ) ) {
                            this.showContestStats = false;
                            this.byContestStats = [
                                {
                                    name: this.getTranslation( 'males' ),
                                    data: [responseData.maleApplied, responseData.maleTookPart, responseData.malePassed]
                                },
                                {
                                    name: this.getTranslation( 'females' ),
                                    data: [responseData.femaleApplied, responseData.femaleTookPart, responseData.femalePassed]
                                },
                            ];

                            this.contestChartOptions = {
                                ...this.contestChartOptions, ...{
                                    colors: ['#ffe9bf', '#C2F1E0'],
                                    chart: {
                                        type: 'bar',
                                        stacked: true,
                                        toolbar: {
                                            show: false,
                                        },
                                        width: "100%",
                                        animations: {
                                            initialAnimation: {
                                                enabled: false
                                            }
                                        }
                                    },
                                }
                            };
                        }
                        else {
                            this.contestChartOptions = {
                                ...this.contestChartOptions, ...{
                                    colors: ['#DEEAFF'],
                                    chart: {
                                        type: 'bar',
                                        stacked: false,
                                        toolbar: {
                                            show: false,
                                        },
                                        width: "100%",
                                        animations: {
                                            initialAnimation: {
                                                enabled: false
                                            }
                                        }
                                    },
                                }
                            };
                            this.byContestStats = [{
                                data: seriesData
                            }];
                        }
                    } ).catch(()=>{})
                .finally( () => {
                    this.showContestStats = true;
                } );
            },

            fetchStatsByDivision( period = PERIOD_DEFAULT ) {
                let params = this.cleanObject( { ...this.filterByDivision, period: period } );
                this.axios.get( this.$config.urls.home.statsByDivision.url, { params: params } )
                    .then( response => {

                    } ).catch(()=>{});
            }
        }
    }
</script>

<style scoped>

</style>
